import React, { useState, useEffect } from "react";
import { deepCopy, oset } from "@/utils";
import { useModal, useWatchState } from "@/store";
import { BaseService } from "@/service";
import { usePage } from "@/store";
import { compose, curry } from "ramda";
import { createSelectOption, checkResult } from "@/common";
import { Modal, Table, Row, Col, Card, Button, Select, Collapse } from "antd";
import "./style.less";
import { ProjectScopeName } from "../projectRec/projectFunction"
const { Panel } = Collapse;

const NAME = "projectNewList";

// 表名称
const TABLE_NAME = "thtt_project";
// key
const TABLE_KEY = "id";
// 要展示的表字段
const TABLE_COLUMNS = "id,name,optimize_name,scope,org_name,orgRec_id,personRec_id,add_date,sort_show";

const App = () => {
    const [recommendOrg, setRecommendOrg] = useState([]);
    const [recommendPerson, setRecommendPerson] = useState([]);
    const [project_scope, setProject_scope] = useState([]);
    const [[modalProps, setProps]] = useWatchState(["modal." + NAME]);
    const { show, hide, width = 1200, height = 750, TypeList } = modalProps;
    const [params, setParams] = useState({
        table: TABLE_NAME,
        columns: TABLE_COLUMNS,
        where: { "thtt_project.is_delete": 0, "thtt_project.last_selected": 1, },
        leftJoin: JSON.stringify([
            {
                table: "thtt_project_recommend",
                on: "thtt_project_recommend.id=thtt_project.orgRec_id",
                columns: ["org_name AS orgRecName"]
            }
        ]),
        order: ["sort_show Asc"],
    })

    const onChangeParams = curry((path, params, value) => {
        oset(params, path, value);
        setParams(deepCopy(params));
    })

    // 列出全部领域
    const getProject_scope = async () => {
        const res = await BaseService.list({
            table: "thtt_scope",
            columns: "id",
            where: {
                level: 2,
                is_delete: 0,
                patent_classify_names: '产业方向'
            },
            order: ["sort Asc"],
        }).then((res) => {
            setProject_scope(res.data.result);
        });
    }

    // 按推荐单位查询
    const getRecommendOrg = async () => {
        const res = await BaseService.list({
            table: "thtt_project_recommend",
            columns: "id,org_name",
            where: {
                identify: 1,
                is_delete: 0,
            },
            order: ["org_category Asc"],
        }).then((res) => {
            setRecommendOrg(res.data.result);
        });
    }

    // 按推荐个人查询
    const getRecommendPerson = async () => {
        const res = await BaseService.list({
            table: "thtt_project_recommend",
            where: {
                identify: 2,
                is_delete: 0,
            },
            order: ["SUBSTRING(org_password,-4) DESC"],
        }).then((res) => {
            setRecommendPerson(res.data.result);
        });
    }

    useEffect((TypeList) => {
        getRecommendOrg(); getRecommendPerson(); getProject_scope();
    }, [TypeList]);

    const onChangeScope = value => {
        if (!value) {
            delete params.where.scope;
        } else {
            params.where.scope = {
                table: "thtt_project",
                value: value,
            }
        }
        setParams(deepCopy(params));
    }
    const onChangeArea = value => {
        if (!value) {
            delete params.where.org_province_name;
        } else {
            params.where.org_province_name = {
                table: "thtt_project",
                value: value,
            }
        }
        setParams(deepCopy(params));
    }
    const [datas, datasControl] = usePage({
        service: BaseService.list,
        params,
        format: res => res.data.result,
    });

    useEffect(() => {
        datasControl.go(1);
    }, [params])

    const handleCancel = () => {
        window.location.reload();
        hide();
    }

    const [projectTopModal] = useModal(["projectTop"]);

    const columns = [
        {
            title: "发布会科技成果名称",
            width: 500,
            dataIndex: 'optimize_name',
            key: 'optimize_name',
        },

        {
            title: "成果申报单位",
            width: 300,
            dataIndex: 'org_name',
            key: 'org_name',
        },
        {

            width: 100,
            dataIndex: 'id',
            key: 'id',
            render: (id) => (
                <div><a onClick={projectTopModal.show.later({ DetailId: id })}>项目预览</a></div>
            )
        },
    ];
    return (
        <Modal
            visible={show}
            width={width}
            height={height}
            maskClosable={false}
            destroyOnClose
            onCancel={handleCancel}
            footer={false}
        >
            {(TypeList == "scopeId") && <div className="listTitle" style={{color:"#fff"}}>请选择所需领域
                <Select
                    style={{ width: "150px", marginLeft: 30, height: 40, backgroundColor: "#999999" }}
                    allowClear
                    size={"large"}
                    placeholder="所属领域"
                    onChange={compose(datasControl.go.later(1), onChangeScope)}>
                    {createSelectOption(
                        project_scope.map(({ id }) => ({
                            label: ProjectScopeName(id),
                            value: id,
                        }))
                    )}
                </Select>
            </div>}
            {(TypeList == "orgRec_id") && <div className="listTitle" style={{color:"#fff"}}>请选择所需推荐单位
                <Select
                    style={{ width: "410px", marginLeft: 30, height: 40 }}
                    allowClear
                    placeholder="请选择推荐单位"
                    onChange={compose(datasControl.go.later(1), onChangeParams("where.orgRec_id", params))}>
                    {createSelectOption(
                        recommendOrg.map(({ org_name, id }) => ({
                            label: org_name,
                            value: id,
                        }))
                    )}
                </Select>
            </div>}
            {(TypeList == "personRec_id") && <div className="listTitle" style={{color:"#fff"}}>请选择推荐个人 <Select
                style={{ width: "410px", marginLeft: 30, height: 40 }}
                allowClear
                className="ml22"
                placeholder="请选择推荐个人"
                onChange={compose(datasControl.go.later(1), onChangeParams("where.personRec_id", params))}>
                {createSelectOption(
                    recommendPerson.map(({ org_name, id }) => ({
                        label: org_name,
                        value: id,
                    }))
                )}
            </Select>
            </div>}
            {(TypeList == "area") && <div className="listTitle" style={{color:"#fff"}}>请选择所需项目地区
                <Select
                    style={{ width: "150px", marginLeft: 20, marginTop: 10, height: 40, backgroundColor: "#999999" }}
                    allowClear
                    placeholder="项目地区"
                    onChange={compose(datasControl.go.later(1), onChangeArea)}>
                    {createSelectOption([{ label: "北京市", value: "北京市" },
                    { label: "上海市", value: "上海市" },
                    { label: "天津市", value: "天津市" },
                    { label: "重庆市", value: "重庆市" },
                    { label: "山东省", value: "山东省" },
                    { label: "安徽省", value: "安徽省" },
                    { label: "江苏省", value: "江苏省" },
                    { label: "浙江省", value: "浙江省" },
                    { label: "湖南省", value: "湖南省" },
                    { label: "湖北省", value: "湖北省" },
                    { label: "四川省", value: "四川省" },
                    { label: "广东省", value: "广东省" },
                    { label: "黑龙江省", value: "黑龙江省" },
                    { label: "内蒙古自治区", value: "内蒙古自治区" },
                    { label: "新疆维吾尔自治区", value: "新疆维吾尔自治区" },
                    ])}
                </Select>
            </div>}
            <div className="tableBg">
                <Table
                    rowKey="id"
                    columns={columns}
                    dataSource={datas.records}
                    size="big"
                    showHeader={true}
                    onChange={datasControl.go.filterProps("current")}
                    scroll={{ x: 800 }}
                    pagination={{ total: datas.total, current: parseInt(datas.current), showQuickJumper: true }}
                    style={{ marginLeft: 20, marginRight: 20, marginBottom: 10, fontSize: 16 }}
                />
            </div>
        </Modal>
    );
}

export default App;